import config from '@common/config.js'
import { PublicClientApplication } from '@azure/msal-browser'

export default new PublicClientApplication(config.get('msalConfig'))
